// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_wrapper__z9eMe","infoService":"wrapper_infoService__H8d9Z","infoServiceTitle":"wrapper_infoServiceTitle__AmC0l"};